import { render, staticRenderFns } from "./CardRolePrizeDrawComponent.vue?vue&type=template&id=87aa7970&scoped=true"
import script from "./CardRolePrizeDrawComponent.vue?vue&type=script&lang=js"
export * from "./CardRolePrizeDrawComponent.vue?vue&type=script&lang=js"
import style0 from "./CardRolePrizeDrawComponent.vue?vue&type=style&index=0&id=87aa7970&prod&lang=css"
import style1 from "./CardRolePrizeDrawComponent.vue?vue&type=style&index=1&id=87aa7970&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87aa7970",
  null
  
)

export default component.exports